import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/ic-closed-folder.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/ic-csv-file.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/ic-doc-file.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/ic-docx-file.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/ic-generic-file.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/ic-jpg-file.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/ic-opened-folder.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/ic-pdf-file.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/ic-png-file.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/ic-ppt-file.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/ic-pptx-file.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/ic-xls-file.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/ic-xlsx-file.png");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/app/src/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/dropdown-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Loader"] */ "/app/src/components/ui/loader.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/scroll-area.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TransitionProvider"] */ "/app/src/lib/action/context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Feedback","FeedbackDialog","FeedbackSwap","FeedbackSlot","FeedbackPopover","FeedbackToast"] */ "/app/src/lib/action/feedback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ActionForm","QueryForm","ActionSubmit"] */ "/app/src/lib/action/form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ActionTrigger"] */ "/app/src/lib/action/trigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccessToastNotifier"] */ "/app/src/lib/auth/accessToastNotifier.ts");
;
import(/* webpackMode: "eager", webpackExports: ["DocumentoMoreButton"] */ "/app/src/lib/documenti/components/documento-more-button.tsx");
